<template>
    <div class="marketing">
        <div class="title">
            <p><span @click="routeTo(`/home/application`)">应用中心</span>><span @click="routeTo(`/home/application`)">营销玩法</span>><span>订单返现</span></p>
            <el-button type="primary" size="medium" plain @click="showHelp">帮助中心</el-button>
        </div>
        <div class="main">
            <div class="card">
                <el-card class="search">
                    <div>
                        <el-button type="primary" size="medium" @click="Create">创建</el-button>
                        <el-button size="medium" type="primary" plain @click="showHelp">使用教程</el-button>
                    </div>
                    <div>
                        <el-form ref="form" :model="form" inline>
                            <el-form-item>
                                <el-select v-model="form.status" placeholder="请选择状态" style="width: 120px" @change="getList(1)">
                                    <el-option v-for="(item, index) in status_opt" :label="item" :value="index" :key="index"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-input v-model="form.name" placeholder="搜索活动名称" clearable></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="medium" type="primary" plain @click="reset">重置</el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="medium" type="primary" @click="getList()">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-card>
                <el-card class="table">
                    <div class="table">
                        <el-table :data="tableData" style="width: 100%">
                            <el-table-column prop="name" label="活动名称" width="180" align="center">
                                <template slot-scope="scope">
                                    <el-tooltip v-if="scope.row.name && scope.row.name.length > 10" :content="scope.row.name" placement="top" effect="light">
                                        <span>{{ scope.row.name | strFmt }}</span>
                                    </el-tooltip>
                                    <span v-else>{{ scope.row.name | strFmt }}</span>
                                </template>
                            </el-table-column>
                          
                            <el-table-column label="开始时间" width="214px" prop="start_time"  align="center" sortable> </el-table-column>
                            <el-table-column label="结束时间" width="214px" prop="end_time" align="center" sortable> </el-table-column>
                            <el-table-column prop="reward_cash" width="214px" label="返现比例或金额" align="center" sortable >
                                <template slot-scope="scope">
                                    <p>{{ Number(scope.row.reward_cash) != 0 ? scope.row.reward_cash + " (元)" : scope.row.reward_share * 100 + " %" }}</p>
                                </template>
                            </el-table-column>
                             <el-table-column label="返现限制" prop="limit_order_num" align="center" width="214px">
                                <template slot-scope="{ row }">
                                    {{ row.limit_order_num ? `限制每人 ${row.limit_order_num} 次` : "不限制" }}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center" width="180" fixed="right">
                                <template slot-scope="scope">
                                    <div class="link">
                                        <el-link v-show="scope.row.activity_status == 3 || scope.row.activity_status == 4" type="primary" @click="Detail(scope.row.id)">查看</el-link>
                                        <el-link v-show="scope.row.activity_status == 1 || scope.row.activity_status == 2" type="primary" @click="Edit(scope.row.id)">编辑</el-link>
                                        <!-- <el-link v-show="scope.row.activity_status != 4" type="primary" @click="getCopyData(scope.row.id)">复制</el-link> -->
                                        <el-link v-show="scope.row.activity_status == 1 || scope.row.activity_status == 2" type="primary" @click="Invalidation(scope.row.id)">失效</el-link>
                                        <el-link v-show="scope.row.activity_status == 3 || scope.row.activity_status == 4" type="danger" @click="Delete(scope.row.id)">删除</el-link>
                                        <!-- <el-link type="primary">效果数据</el-link> -->
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pageSize">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="page"
                                :page-sizes="page_siezs"
                                :page-size="size"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                                background
                            >
                            </el-pagination>
                        </div>
                    </div>
                </el-card>
            </div>
            <Slide @show="showHelp" :dataList="dataList"></Slide>
        </div>

        <!-- 帮助中心 -->
        <Help ref="refHelp" :status_opt="status_opt"></Help>
        <!-- 商品列表 -->
        <GoodsList
            ref="goodsList"
            @CancelSpec="CancelSpec"
            @Cancel="Cancel"
            :activityId="activityId"
            :activityProductData="activityProductData"
            :params_type="params_type"
            @close="goodsListClose"
            @showDetail="showDetail"
        ></GoodsList>
        <!-- 商品详情 -->
        <GoodsDetail ref="goodsDetail" :params_type="params_type" :type="type" @postDetailData="postDetailData"></GoodsDetail>
        <!-- 创建编辑 -->
        <CreateOrEdit
            :noProductEdit="noProductEdit"
            :edit_id="edit_id"
            ref="refCreateOrEdit"
            @initList="initList"
            @dataInit="dataInit"
            :count="count"
            :activityProductData="activityProductData"
            @showGoods="showGoods"
            @showSelDetail="showSelDetail"
            :isDetail="isDetail"
        ></CreateOrEdit>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import Help from "@/components/Modules/Application/Help.vue";
import Slide from "@/components/Modules/Application/Slide.vue";
import GoodsList from "@/components/Modules/Application/goodsList.vue";
import GoodsDetail from "@/components/Modules/Application/goodsDetail.vue";
import CreateOrEdit from "@/components/Modules/Application/OrderCashback/CreateOrEdit.vue";
export default {
    data() {
        return {
            params_type: "activity_share_product",
            activeType: "订单返现",
            page: 1,
            size: 10,
            total: 0,
            page_siezs: [10, 20, 30, 40],
            form: {
                status: "",
                name: "",
            },
            activeName: "0",
            tableData: [],
            status_opt: ["全部状态", "未开始", "进行中", "已结束", "失效"],
            dataList: [],
            count: 0,
            type: 1,
            activityProductData: [], //所选商品
            edit_id: 0,
            noProductEdit: 0,
            goods_id: 0,
            id_key: [], //存储编辑时活动id数据
            activityId: 0,
            isDetail: false,
        };
    },
    filters: {
        strFmt(val) {
            if (val) {
                if (val.length > 10) {
                    return val.substring(0, 10) + "...";
                }
                return val;
            }
            return "-";
        },
    },
    components: {
        Help,
        Slide,
        GoodsList,
        GoodsDetail,
        CreateOrEdit,
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    mounted() {
        this.getArticle();
        this.getList(1);
    },
    methods: {
        ...mapActions({
            // 订单返现列表
            getActivityList: "activity/getActivityList",
            // 复制
            activityCopy: "activity/activityCopy",
            // 删除
            deleteActivity: "activity/deleteActivity",
            // 失效
            invalidActivity: "activity/invalidActivity",
            // 推荐文章列表
            getArticleApi: "activity/getArticleCategory",
            // 详情
            getProductDetail: "activity/getProductDetail",
            // 已选商品
            getProductSelected: "activity/getProductSelected",
        }),

        // 多规格取消
        CancelSpec(row) {
            this.activityProductData = this.activityProductData.filter((item, index) => {
                return item.goods_id != row.id;
            });
            this.count = this.activityProductData.length;
        },
        // 单规格取消
        Cancel(row) {
            this.activityProductData = this.activityProductData.filter((item, index) => {
                return item.spuId != row.id;
            });
            this.count = this.activityProductData.length;
        },
        // 初始化已选商品
        initList() {
            this.getList(1);
        },
        // 编辑页面初始化商品
        dataInit() {
            this.noProductEdit = 0;
            this.edit_id = 0;
            this.count = 0;
            this.activityProductData = [];
        },
        // 显示商品详情，数据处理
        showDetail(row, date) {
            this.goods_id = row.id;
            this.$refs.goodsDetail.dialogVisible = true;
            this.type = Number(row.goods_specifications_type_id);
            if (row.goods_specifications_type_id == 1) {
                let _row = JSON.parse(JSON.stringify(row));
                _row.reward_cash = Number(_row.reward_cash) ? Number(_row.reward_cash) : "";
                _row.reward_share = Number(_row.reward_share) ? Number(_row.reward_share) * 100 : "";
                this.$refs.goodsDetail.tableDataD = [_row];
            } else {
                let params = {
                    token: this.getToken,
                    spuId: row.id,
                    startTime: date ? date[0] : null,
                    endTime: date ? date[1] : null,
                    name: this.params_type,
                };
                if (row.select_product.activity_product_id) {
                    params.activityId = this.activityId;
                }
                this.getProductDetail(params).then(({ data }) => {
                    if (data.code == 1) {
                        if (data.data.sku_data && data.data.sku_data.length > 0) {
                            data.data.sku_data.forEach((item) => {
                                item.goods_id = data.data.id;
                                item.tits = data.data.tits;
                                item.goods_specifications_type_id = data.data.goods_specifications_type_id;
                            });
                            this.activityProductData.forEach((item) => {
                                data.data.sku_data.forEach((val) => {
                                    if (val.id == item.skuId) {
                                        val.total_stock = Number(item.total_stock);
                                        val.reward_cash = Number(item.reward_cash);
                                        val.reward_share = Number(item.reward_share) * 100;
                                        val.checked = true;
                                        val.goods_id = data.data.id;
                                    }
                                });
                            });
                            this.$refs.goodsDetail.bindData(data.data.sku_data);
                        }
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            }
        },
        goodsListClose() {
            // this.count = 0;
            // this.activityProductData = [];
        },
        Create() {
            this.isDetail=false;
            this.activityId = 0;
            this.edit_id = 0;
            this.$refs.refCreateOrEdit.dialogVisible = true;
        },
        // 显示商品列表
        showSelDetail() {
            this.$refs.goodsDetail.dialogVisible = true;
        },
        // 提交需求单
        postDetailData(arr, type, list) {
            this.noProductEdit = 1;
            if (type == 1) {
                list.forEach((item) => {
                    this.id_key = this.id_key.filter((val) => {
                        return item.id != val.spuId;
                    });
                    this.activityProductData = this.activityProductData.filter((val) => {
                        return item.id != val.spuId;
                    });
                });
                arr.forEach((item) => {
                    let obj = {
                        skuId: 0,
                        spuId: Number(item.id),
                        total_stock: item.total_stock ? item.total_stock : "",
                        reward_cash: item.reward_cash ? item.reward_cash : "",
                        reward_share: item.reward_share ? item.reward_share : "",
                    };
                    if (item.select_product.activity_product_id) {
                        obj.id = item.select_product.activity_product_id;
                    }
                    if (this.is_open_leader_price == 1) {
                        obj.leader_price = item.leader_price ? item.leader_price : "";
                    }
                    this.id_key.push(obj);
                    this.activityProductData.push(obj);
                });
            } else {
                list.forEach((item) => {
                    this.id_key = this.id_key.filter((val) => {
                        return item.id != val.skuId;
                    });
                    this.activityProductData = this.activityProductData.filter((val) => {
                        return item.id != val.skuId;
                    });
                });
                arr.forEach((item) => {
                    let obj = {
                        skuId: Number(item.id),
                        spuId: 0,
                        total_stock: item.total_stock ? item.total_stock : "",
                        reward_cash: item.reward_cash ? item.reward_cash : "",
                        reward_share: item.reward_share ? item.reward_share : "",
                        goods_id: item.goods_id,
                    };
                    if (item.select_product.activity_product_id) {
                        obj.id = item.select_product.activity_product_id;
                    }
                    if (this.is_open_leader_price == 1) {
                        obj.leader_price = item.leader_price ? item.leader_price : "";
                    }
                    this.id_key.push(obj);
                    this.activityProductData.push(obj);
                });
            }

            this.activityProductData.forEach((item) => {
                if (typeof item.spuId == 0) {
                    delete item.spuId;
                }
                if (typeof item.skuId == 0) {
                    delete item.skuId;
                }
            });
            this.count = this.activityProductData.length;
            this.$refs.goodsList.reset();
        },
        // 显示商品
        showGoods(date) {
            this.$refs.goodsList.dialogVisible = true;
            this.$refs.goodsList.date = date;
            this.$refs.goodsList.reset();
        },
        // 获取推荐文章
        getArticle() {
            let params = {
                token: this.getToken,
                code: this.activeType,
            };
            this.getArticleApi(params).then(({ data }) => {
                if (data.code == 1) {
                    this.dataList = data.data.filter((item, index) => {
                        return item.code.indexOf("教程") == -1 && index < 5;
                    });
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 失效操作
        Invalidation(id) {
            this.$confirm("是否确认修改此条数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let params = {
                        token: this.getToken,
                        id: id,
                    };
                    this.invalidActivity(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success("修改成功！");
                            this.getList();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消修改",
                    });
                });
        },
        // 删除操作
        Delete(id) {
            this.$confirm("是否确认删除此条数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let params = {
                        token: this.getToken,
                        id: id,
                    };
                    this.deleteActivity(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success("删除成功！");
                            this.getList();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // 复制
        getCopyData(id) {
            let params = {
                token: this.getToken,
                id: id,
            };
            this.activityCopy(params).then(({ data }) => {
                if (data.code == 1) {
                    this.$message.success("复制成功，请前往列表查看！");
                    this.getList();
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        /**
         * type - 操作类型
         * id - 操作数据id
         */
        showHelp() {
            this.$refs.refHelp.dialogVisible = true;
            this.$refs.refHelp.active = JSON.parse(JSON.stringify(this.activeType));
            this.$refs.refHelp.getResult();
        },
        // 显示详情获取接口数据
        Detail(id) {
            this.activityId = Number(id);
            this.edit_id = Number(id);
            this.isDetail = true;
            this.getSelectedGoods(id);
            this.$refs.refCreateOrEdit.dialogVisible = true;
            this.$refs.refCreateOrEdit.getDetail(id);
        },
        getSelectedGoods(id) {
            let params = {
                token: this.getToken,
                activityId: id,
                name: this.params_type,
            };
            this.getProductSelected(params).then(({ data }) => {
                if (data.code == 1) {
                    if (data.data && data.data.length > 0) {
                        data.data.forEach((item) => {
                            if (item.skuId != 0) {
                                item.goods_id = Number(item.spuId);
                                item.spuId = 0;
                            }
                            item.skuId = Number(item.skuId);
                        });
                        this.activityProductData = data.data;
                        this.id_key = data.data;
                        this.count = data.data.length;
                    }
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        Edit(id) {
            this.activityId = Number(id);
            this.edit_id = Number(id);
            this.isDetail=false;
            this.getSelectedGoods(id);
            this.$refs.refCreateOrEdit.dialogVisible = true;
            this.$refs.refCreateOrEdit.getDetail(id);
        },
        // 重置
        reset() {
            this.form = {
                status: "",
                name: "",
            };
            this.page = 1;
            this.getList(1);
        },
        // 获取列表数据
        getList(tag) {
            let params = {
                token: this.getToken,
                page: tag == 1 ? tag : this.page,
                size: this.size,
                search_status: this.form.status,
                name: this.form.name,
            };
            this.getActivityList(params).then(({ data }) => {
                if (data.code == 1) {
                    this.tableData = data.data.list;
                    this.total = data.data.count;
                    if (data.data.count > 0 && data.data.list.length == 0) {
                        this.page -= 1;
                        this.getList();
                    }
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 路由跳转
        routeTo(path) {
            this.$router.push({ path: path });
        },
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
    },
};
</script>
<style lang="scss" scoped>
.marketing {
    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;
        font-size: 18px;
        justify-content: space-between;
        color: #333;
        p {
            color: #333;
            span {
                margin: 0 8px;
                cursor: pointer;
                &:hover {
                    color: #409eff;
                }
                &:first-child {
                    margin-left: 0;
                }
                &:last-child {
                    &:hover {
                        color: #333;
                    }
                }
            }
        }
    }
    .main {
        width: 100%;
        display: flex;
        .card {
            flex: 1;
            margin-right: 10px;
            width: 800px;
        }
    }
    .el-card {
        margin: 24px 0px 10px 24px;
        border-radius: 0;
        padding: 24px;
        &:nth-child(2) {
            margin: 10px 0px 24px 24px;
        }
    }
    .search {
        ::v-deep .el-card__body {
            padding: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .table {
        ::v-deep th {
            background: #fafafa !important;
        }
        ::v-deep .el-table__body-wrapper {
            min-height: 470px;
            overflow-y: auto;
        }
        .el-table::before {
            display: none;
        }
        .pageSize {
            text-align: right;
            margin-top: 20px;
        }
    }
    ::v-deep .el-card__body {
        padding: 0;
    }
    .link {
        a {
            margin: 0 8px;
        }
    }
}
::v-deep .el-table__fixed-right::before {
    display: none;
}
</style>